import { call, put } from "redux-saga/effects";
import { API_URL, ACTIONS } from "../_config";
import { CallApi } from "./api/callApi";

export function* getSubscriptionPlans(action: any): any {
  try {
    const resp = yield call(CallApi.GET, API_URL.SUBSCRIPTION.GET_SUBSCRIPTION_PLANS, action.payload, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* createPayment(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.SUBSCRIPTION.CREATE_PAYMENT, action.payload, true);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* paymentSuccess(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.SUBSCRIPTION.PAYMENT_SUCCESS, action.payload, true);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    console.log("Error in paymentSuccess saga:", e);
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* paymentCancel(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.SUBSCRIPTION.PAYMENT_CANCEL, action.payload, true);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data?.message || "Payment cancelled", resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getInvoices(action: any): any {
  try {
    const params: any = {};
    if (action.payload?.per_page) params.per_page = action.payload.per_page;
    if (action.payload?.page !== undefined) params.page = action.payload.page;
    if (action.payload?.limit) params.limit = action.payload.limit;
    if (action.payload?.offset !== undefined) params.offset = action.payload.offset;

    console.log("getInvoices saga params:", params);

    const resp = yield call(CallApi.GET, API_URL.SUBSCRIPTION.GET_INVOICES, params, true);
    console.log("getInvoices response:", resp.data);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    console.log("Error in getInvoices saga:", e);
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* cancelSubscription(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.SUBSCRIPTION.CANCEL_SUBSCRIPTION, action.payload, true);

    if (resp.status >= 200 && resp.status < 300) {
      action &&
        action.callbackSuccess &&
        action.callbackSuccess(resp.data?.message || "Subscription cancelled successfully", resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    console.log("Error in cancelSubscription saga:", e);
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

